// import {getConfig} from '@/api/config'
import store from '@/store'
import { getToken } from '@/utils/auth'
const token = getToken()
// if(token){
//   getConfig().then(res=>{
//     console.log(res);
//     store.dispatch('config/changeConfig', {
//         key: 'title',
//         value: res.data.name
//       })
//       store.dispatch('config/changeConfig', {
//         key: 'logo',
//         value: res.data.logo
//       })
//       console.log(store.getters.sidebar_log);
//       console.log(store.getters.web_title);
// }
// )}
